import { createTheme, Theme } from '@mui/material/styles'
import { PaletteMode, PaletteOptions } from '@mui/material'

/**
 * Token-based MUI theme. Colors/typography/shape live here as named tokens rather than being
 * inlined at call sites, so a future rebrand is a edit-in-one-place change.
 */
const typography = {
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    'Helvetica',
    'Arial',
    'sans-serif',
  ].join(','),
}

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1600,
  },
}

const tokens: Record<PaletteMode, PaletteOptions> = {
  light: {
    mode: 'light',
    primary: { main: '#2F5D62' },
    secondary: { main: '#B4654A' },
    background: { default: '#FAFAFA', paper: '#FFFFFF' },
  },
  dark: {
    mode: 'dark',
    primary: { main: '#5FA8AD' },
    secondary: { main: '#D98B6F' },
    background: { default: '#121212', paper: '#1D1D1D' },
  },
}

export const createAppTheme = (mode: PaletteMode): Theme =>
  createTheme({
    breakpoints,
    palette: tokens[mode],
    typography,
    shape: {
      borderRadius: 4,
    },
  })

const theme = createAppTheme('light')
export const darkTheme = createAppTheme('dark')

export default theme
